import React from 'react';
import PropTypes from 'prop-types';
import appColors from '../../app_colors';

const { wholeMeAssets: { primary } } = appColors;

const dotsStyle = {
  display: 'flex',
  flexWrap: 'nowrap',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: 'fit-content',
  gap: '10px',
  marginTop: '20px',
};

const ProgressDots = ({
  totalNumber, activeNumber, maxVisibleDots = 8, styleOverride,
}) => {
  const startIndex = Math.floor(activeNumber / maxVisibleDots) * maxVisibleDots;
  const endIndex = Math.min(startIndex + maxVisibleDots, totalNumber);

  return (
    <div style={dotsStyle}>
      {[...Array(totalNumber).keys()]
        .slice(startIndex, endIndex)
        .map((dot) => {
          const isActiveDot = dot === activeNumber;
          return (
            <div
              key={dot}
              style={{
                borderRadius: '50%',
                width: isActiveDot ? '19px' : '11px',
                height: isActiveDot ? '19px' : '11px',
                backgroundColor: primary,
                ...styleOverride,
              }}
            />
          );
        })}
    </div>
  );
};

const ProgressDotsPropTypes = {
  totalNumber: PropTypes.number.isRequired,
  activeNumber: PropTypes.number.isRequired,
  maxVisibleDots: PropTypes.number,
};


ProgressDots.propTypes = ProgressDotsPropTypes;

export default ProgressDots;
